import { render, staticRenderFns } from "./WeeklyBudgetTable.vue?vue&type=template&id=ae5960bc&scoped=true&"
import script from "./WeeklyBudgetTable.vue?vue&type=script&lang=js&"
export * from "./WeeklyBudgetTable.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyBudgetTable.vue?vue&type=style&index=0&id=ae5960bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5960bc",
  null
  
)

export default component.exports